import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }
const _hoisted_2 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"20px"} }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_ctx.form!=null && _ctx.form!=undefined)
    ? (_openBlock(), _createBlock(_component_el_dialog, {
        key: 0,
        modelValue: _ctx.Visible,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.Visible) = $event)),
        "show-close": false,
        style: {"width":"40%"},
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true
      }, {
        header: _withCtx(({ close }) => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.title), 1),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_icon, {
              style: {"cursor":"pointer"},
              onClick: close
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CloseBold)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        default: _withCtx(() => [
          (_ctx.form.Data)
            ? (_openBlock(), _createBlock(_component_el_form, {
                key: 0,
                ref: "ruleFormAssign",
                model: _ctx.form.Data,
                rules: _ctx.form.Rules
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "执行人",
                    "label-width": "120px",
                    prop: "SelectJoinCompanyUserId"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_miezz_select, {
                        modelValue: _ctx.form.Data.SelectJoinCompanyUserId,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.Data.SelectJoinCompanyUserId) = $event)),
                        options: _ctx.users,
                        clearable: false,
                        valueKey: "Value",
                        labelKey: "Label",
                        style: {"width":"100% !important"},
                        onHandleChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChangeUserId()))
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"]))
            : _createCommentVNode("", true),
          _hoisted_3,
          _createVNode(_component_miezz_button_bar, {
            modelValue: _ctx.bottomButtons,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.bottomButtons) = $event)),
            isBackground: true,
            onHandleClick: _ctx.handleClick
          }, null, 8, ["modelValue", "onHandleClick"])
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}